import { render, staticRenderFns } from "./ChamadoLista.vue?vue&type=template&id=6b762200&scoped=true&"
import script from "./ChamadoLista.vue?vue&type=script&lang=js&"
export * from "./ChamadoLista.vue?vue&type=script&lang=js&"
import style0 from "./ChamadoLista.vue?vue&type=style&index=0&id=6b762200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b762200",
  null
  
)

export default component.exports